<template>
  <header class="bg-gradient-to-r from-gray-800 to-gray-900 text-white sticky top-0 z-50 shadow-lg">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16 md:h-20">
        <!-- Logo Section -->
        <router-link
            to="/"
            class="flex items-center space-x-2 transform hover:scale-105 transition-all duration-300"
        >
          <span class="text-2xl md:text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-300">
            USMANHEART OÜ
          </span>
        </router-link>

        <!-- Navigation Menu -->
        <nav class="hidden md:block">
          <ul class="flex items-center space-x-6 lg:space-x-8">
            <li v-for="(item, index) in navItems" :key="index">
              <router-link
                  :to="item.link"
                  class="relative px-3 py-2 text-sm font-medium hover:text-blue-300 transition-colors group"
                  active-class="text-blue-400"
              >
                {{ item.name }}
                <span class="absolute inset-x-1 -bottom-px h-px bg-gradient-to-r from-blue-400/0 via-blue-400 to-blue-400/0 opacity-0 group-hover:opacity-100 transition-opacity"></span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderView",
  data() {
    return {
      navItems: [
        { name: "About Us", link: "/about-us" },
        { name: "Privacy Policy", link: "/privacy-policy" },
        { name: "Selling Policy", link: "/selling-privacy-policy" },
      ],
    };
  },
};
</script>
